import { tryParseFloat } from "client/Misc/parseUtils";
import styles from "./tableRendering.module.less";
import { isSafari } from "client_legacy/ndaw/mobile";

export const cellMinWidth = 25;

export function applyTableStylesToViewer(container: HTMLDivElement): void {
	const tables: NodeListOf<HTMLTableElement> = container.querySelectorAll("table");

	tables.forEach(
		table => {
			wrapTable(table);
			applyTableWidth(table);
		}
	);
}

function wrapTable(table: HTMLTableElement): void {
	const parent: ParentNode | null = table.parentNode;

	if (!parent) {
		throw new Error("Table does not have a parent node.");
	}

	if (isWrapper(parent)) {
		return;
	}

	const wrapper: HTMLDivElement = document.createElement("div");
	wrapper.classList
		.add(styles.tableWrapper);

	if (isSafari()) {
		wrapper.classList
			.add(styles.tableWrapper_applySafariFix);
	}

	parent.insertBefore(wrapper, table);

	wrapper.appendChild(table);
}

function isWrapper(node: ParentNode): boolean {
	return node instanceof HTMLDivElement
		&& node.classList
			.contains(styles.tableWrapper);
}

function applyTableWidth(table: HTMLTableElement): void {
	const firstRow: HTMLTableRowElement | null = table.querySelector("tr");

	if (!firstRow) {
		return;
	}

	const cells: NodeListOf<HTMLTableCellElement> = firstRow.querySelectorAll("td");

	let totalWidth: number = 0;
	let doAllColumnsHaveWidth: boolean = true;

	cells.forEach(
		cell => {
			const rawWidth: string | undefined = cell.dataset["colwidth"];

			const parsing: TryResult<number> = tryParseFloat(rawWidth);

			if (parsing.wasSuccessful) {
				totalWidth += parsing.result;
			} else {
				totalWidth += cellMinWidth;
				doAllColumnsHaveWidth = false;
			}
		}
	);

	if (totalWidth > 0) {
		if (doAllColumnsHaveWidth) {
			table.style.width = totalWidth + "px";
		} else {
			table.style.minWidth = totalWidth + "px";
		}
	}
}